<template>
    <table-base :filter="filter" :headers="headers" :api-data="apiData" :sorting="sorting" :items-field="itemsField" :edit-page-name="editPageName" :api-method="apiMethod" :claim-name="claimName" :form-title="formTitle" :excel-title="excelTitle" :has-edit-page="hasEditPage" :table-form="loadMovementForm" :refresh-key="refreshKey" :show-expand="$route.name == 'auditEditor'" :has-import="true">
        <template v-slot:expand="{ item, refreshKey }">
            <component :is="loadMovement" v-if="$route.name == 'auditEditor'" :item-id="item.id" :refresh-key="refreshKey" :filter="filter" />
        </template>
    </table-base>
</template>

<script>
    export default {
        props: [
            'filter',
            'refreshKey'
        ],
        components: {
            tableBase: () => import('../components/TableBase'),
        },
        data() {
            return {
                loadMovementForm: () => import('../forms/LoadMovementForm'),
                loadMovement: () => import('../editViews/LoadMovement'),
                headers: [
                    { text: 'From Site', value: 'fromSiteId', table: 'sites', form: () => import('../forms/SiteForm') },
                    { text: 'To Site', value: 'toSiteId', table: 'sites', form: () => import('../forms/SiteForm') },
                    { text: 'Load', value: 'loadId', table: 'loads', form: () => import('../forms/LoadForm') },
                    { text: 'On', value: 'on', format: this.formatDate },
                    { text: 'Number Of Hives', value: 'numberOfHives' },
                    { text: '', value: 'action' }
                ],
                apiData: {
                    sites: [],
                    loads: [],
                    items: []
                },
                sorting: [
                    { column: "on", direction: "descending" },
                    { column: "fromSiteId", direction: "ascending" },
                    { column: "toSiteId", direction: "ascending" },
                    { column: "loadId", direction: "ascending" },
                ],
                itemsField: 'loadMovements',
                editPageName: 'loadMovement',
                apiMethod: 'LoadMovements',
                claimName: 'LoadMovements',
                formTitle: 'Load Movement',
                excelTitle: 'Load Movements',
                hasEditPage: true,
            }
        },
    };
</script>
